import React from 'react';
import Section from '../Section';
import SectionContents from '../SectionContents';
import styles from './Global.module.scss';
import SectionContentsBody from '../SectionContentsBody';

function Index() {
  return (
    <Section removePad="bottom">
      <SectionContents
        sizes={{xs: [12, 12], lg: [12, 12]}}
        className={styles['global-section']}
      >
        <SectionContentsBody
          title="Global Collaboration for Reliable Certification Verification"
          description="IAF CertSearch is the only global platform backed by the International Accreditation Forum (IAF), accreditation bodies, and certification bodies. It enables industry, regulators, and governments to verify ISO certification and other accredited international, national, and sector standard certifications quickly and accurately."
        />
      </SectionContents>
    </Section>
  );
}

export default Index;
